export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "no_active_challenge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas de challenge en cours."])}
      },
      "en": {
        "no_active_challenge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No challenge running."])}
      }
    }
  })
}
